/**
 * GiftCardSummaryCard — card number, status, balance and customer block
 * (BON-223 detail page). Repeats every field the list row carries, plus the
 * credited/debited split the ledger below explains.
 */
import { CopyButton } from '../shared/CopyButton';

import { GiftCardBalanceBlock } from './GiftCardBalanceBlock';
import { GiftCardCustomerBlock } from './GiftCardCustomerBlock';
import { GiftCardDetailField } from './GiftCardDetailField';
import { cardNumberLabel, formatCreatedDate, sourceLabel } from './giftCardsModel';
import { GiftCardStatusPill } from './GiftCardStatusPill';
import type { GiftCardDetail } from './giftCardTypes';

export function GiftCardSummaryCard({ card }: { card: GiftCardDetail }) {
  return (
    <section className="nb-card" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 160 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, fontSize: 17 }}>
            <div
              className="nb-mono"
              style={{
                minWidth: 0,
                fontWeight: 700,
                color: 'var(--nb-ink)',
                letterSpacing: '.05em',
              }}
            >
              {cardNumberLabel(card)}
            </div>
            {card.code && <CopyButton value={card.code} what="card number" />}
          </div>
          {!card.code && (
            <div style={{ fontSize: 11.5, color: 'var(--nb-subtle)', marginTop: 3 }}>
              Last 5 characters shown
            </div>
          )}
        </div>
        <GiftCardStatusPill status={card.status} />
      </div>

      <GiftCardBalanceBlock card={card} />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 14,
          borderTop: '1px solid var(--nb-border)',
          paddingTop: 14,
        }}
      >
        <GiftCardDetailField label="Source">
          <span style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--nb-muted)' }}>
            {sourceLabel(card.source)}
          </span>
        </GiftCardDetailField>
        <GiftCardDetailField label="Created">
          {formatCreatedDate(card.createdAt)}
        </GiftCardDetailField>
      </div>

      <GiftCardCustomerBlock customer={card.customer} />
    </section>
  );
}
